import { render, staticRenderFns } from "./privacyPolicy.vue?vue&type=template&id=2e6b7932&scoped=true"
import script from "./privacyPolicy.vue?vue&type=script&lang=js"
export * from "./privacyPolicy.vue?vue&type=script&lang=js"
import style0 from "./privacyPolicy.vue?vue&type=style&index=0&id=2e6b7932&prod&lang=scss"
import style1 from "./privacyPolicy.vue?vue&type=style&index=1&id=2e6b7932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6b7932",
  null
  
)

export default component.exports